import { useFischer } from '@/composables/fischerPlugin';

export const useSearchLocation = () => {
  const fischer = useFischer();

  const getSearchLocation = (query: string) => {
    const searchUrl = fischer.pages.search().url;
    if (query) {
      return `${searchUrl}?query=${encodeURIComponent(query)}`;
    }
    return searchUrl;
  };

  return { getSearchLocation };
};
